module.exports = __webpack_public_path__ + "img/horizontal_3_3_8003.defd034b.png";